import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const Make = ({ make }: SpecProps<"make">) => {
  const { i18n } = useLingui();

  if (make == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.make",
    message: "Make",
    comment: "Field for 'make' in ad specification",
  });
  return <FieldValuePair field={field} value={make} />;
};
